import styled, { css } from 'styled-components'
import { MEDIA } from 'utils/constants'

const { MOBILE } = MEDIA

export const ModalDialog = styled.div`
  position: ${props => props.visible ? 'fixed' : 'static'};
  float: left;
  left: 50%;
  top: ${props => props.$modalTop || '50%'};
  transform: ${props => props.$modalTop ? 'translateX(-50%)' : 'translate(-50%, -50%)'};
  z-index: ${props => props.visible ? 1073 : -100};
  margin-top: ${props => props.$modalTop ? props.$modalTop : '0'};
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: ${props => props.$modalWidth || '100vw'};
  max-width: ${props => props.$modalWidth ? '95vw' : '100vw'};
  height: ${props => props.$modalTop ? '80vh' : '100vh'};
  background-color: var(--the-white);
  transition: all 0.05s ease-in;
  opacity: ${props => props.visible ? 1 : 0};
  display: ${props => props.visible ? 'block' : 'none'};
  border-radius: 2.4rem;
  padding: 24px;
  gap: 16px;
  ${props => props.$modalHeight ? `height:${props.$modalHeight};` : 'fit-content'};

  ${props => props.$modalWidth && css`
    max-height: ${props => props.$modalTop ? `calc(100vh - ${props.$modalTop} - 24px)` : '95vh'};

    @media screen and ${MOBILE} {
      width: 100vw;
      max-width: 100vw;
      max-height: 100vh;
    }
  `}
`

export const ModalClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  line-height: 24px;
  right: 16px;
  top: 16px;
  position: absolute;
  border: none;
  background: none;
  cursor: pointer;
`

export const ModalBackdrop = styled.span`
  display: ${props => props.visible ? 'flex' : 'none'};
  align-items:center;
  justify-content:center;
  content: '';
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1072;
`
